export enum ReportsSortBy {
  ActualDate = 'actualDate',
  AssignedAgent = 'assignedAgent',
  ClosedCount = 'closedCount',
  DaysOverdue = 'daysOverdue',
  DurationDays = 'durationDays',
  FoundationPercent = 'foundationPercent',
  ForecastDate = 'forecastedDate',
  NetChange = 'netChange',
  NewCount = 'newCount',
  Period = 'period',
  ProjectBundleID = 'projectBundleID',
  ProjectStatus = 'projectStatus',
  ProjectType = 'projectType',
  ProgressStatus = 'progressStatus',
  SiteName = 'siteName',
  StructuralResult = 'structuralResult',
  TaskName = 'taskName',
  TowerPercent = 'towerPercent',
}
